/*
 * Eigene Datei, damit `index.ts` und `spanne.ts` dieselbe Rechnung nutzen, ohne sich gegenseitig
 * zu importieren (Kreisimport, vgl. `paket-preisart.ts`). Zusammengeführt aus B2 (#1506) und B3.
 */
/**
 * Betrag je Gast: Gesamtbetrag geteilt durch die Gästezahl, auf ganze Cent gerundet — dieselbe
 * Rechnung wie `perPersonCents` in `index.ts` (sie nutzt diese Funktion). `null` ohne Gäste: „pro Person“
 * gibt es dann nicht, und 0,00 € wäre eine falsche Aussage.
 *
 * Buchungsstrecke B2: die neue Angebotsseite zeigt „pro Person“ und „gesamt“ gleichwertig; beide
 * Zahlen kommen vom Server (routes/public-offer.ts → lib/angebotsseite-v2.ts), der Browser rechnet
 * nichts.
 */
export function proPersonCents(totalCents: number, gaeste: number | null | undefined): number | null {
  if (typeof gaeste !== "number" || !Number.isFinite(gaeste) || gaeste <= 0) return null;
  if (typeof totalCents !== "number" || !Number.isFinite(totalCents)) return null;
  return Math.round(totalCents / gaeste);
}
